import { Link } from "react-router-dom";
import { Truck, Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#1A2A3A] text-white mt-24" data-testid="site-footer">
      <div className="container mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 bg-[#2BD391] rounded-full flex items-center justify-center">
                <Truck className="w-5 h-5 text-white" />
              </div>
              <div className="font-heading font-extrabold text-xl text-white">Annuaire</div>
            </Link>
            <p className="text-sm text-gray-300 leading-relaxed">
              La plateforme française qui simplifie votre déménagement. Annuaire d'entreprises de déménagement — mise en relation avec nos partenaires.
            </p>
          </div>

          <div>
            <div className="eyebrow text-[#2BD391] mb-4">Navigation</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-gray-300 hover:text-[#2BD391]">Accueil</Link></li>
              <li><Link to="/villes" className="text-gray-300 hover:text-[#2BD391]">Toutes les villes</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-blog">Blog déménagement</Link></li>
              <li><Link to="/demenagement-paris-lyon" className="text-gray-300 hover:text-[#2BD391]">Paris → Lyon</Link></li>
              <li><Link to="/demenagement-paris-bordeaux" className="text-gray-300 hover:text-[#2BD391]">Paris → Bordeaux</Link></li>
              <li><Link to="/demenagement-paris-marseille" className="text-gray-300 hover:text-[#2BD391]">Paris → Marseille</Link></li>
              <li><Link to="/demenagement-paris-lille" className="text-gray-300 hover:text-[#2BD391]">Paris → Lille</Link></li>
              <li><Link to="/devis" className="text-gray-300 hover:text-[#2BD391]">Demander un devis</Link></li>
              <li><Link to="/a-propos" className="text-gray-300 hover:text-[#2BD391]">Comment ça marche</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow text-[#2BD391] mb-4">Régions</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/demenagement/ile-de-france" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-region-idf">Île-de-France</Link></li>
              <li><Link to="/demenagement/auvergne-rhone-alpes" className="text-gray-300 hover:text-[#2BD391]">Auvergne-Rhône-Alpes</Link></li>
              <li><Link to="/demenagement/provence-alpes-cote-d-azur" className="text-gray-300 hover:text-[#2BD391]">PACA</Link></li>
              <li><Link to="/demenagement/occitanie" className="text-gray-300 hover:text-[#2BD391]">Occitanie</Link></li>
              <li><Link to="/demenagement/nouvelle-aquitaine" className="text-gray-300 hover:text-[#2BD391]">Nouvelle-Aquitaine</Link></li>
              <li><Link to="/demenagement/hauts-de-france" className="text-gray-300 hover:text-[#2BD391]">Hauts-de-France</Link></li>
              <li><Link to="/demenagement/grand-est" className="text-gray-300 hover:text-[#2BD391]">Grand Est</Link></li>
              <li><Link to="/demenagement/pays-de-la-loire" className="text-gray-300 hover:text-[#2BD391]">Pays de la Loire</Link></li>
              <li><Link to="/demenagement/bretagne" className="text-gray-300 hover:text-[#2BD391]">Bretagne</Link></li>
              <li><Link to="/demenagement/normandie" className="text-gray-300 hover:text-[#2BD391]">Normandie</Link></li>
              <li><Link to="/demenagement/centre-val-de-loire" className="text-gray-300 hover:text-[#2BD391]">Centre-Val de Loire</Link></li>
              <li><Link to="/demenagement/bourgogne-franche-comte" className="text-gray-300 hover:text-[#2BD391]">Bourgogne-Franche-Comté</Link></li>
              <li><Link to="/demenagement/corse" className="text-gray-300 hover:text-[#2BD391]">Corse</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow text-[#2BD391] mb-4">Légal</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/mentions-legales" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-legal">Mentions légales</Link></li>
              <li><Link to="/cgu" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-cgu">CGU / CGV</Link></li>
              <li><Link to="/confidentialite" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-privacy">Confidentialité</Link></li>
              <li><Link to="/cookies" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-cookies">Cookies & RGPD</Link></li>
              <li><Link to="/referencement" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-referencement">Référencement et classement</Link></li>
              <li><button type="button" onClick={() => window.__openCookieBanner && window.__openCookieBanner()} className="text-gray-300 hover:text-[#2BD391] text-left" data-testid="footer-manage-cookies">Gérer mes cookies</button></li>
              <li><Link to="/mentions-legales-b2b" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-b2b">Annuaire B2B</Link></li>
              <li><Link to="/fiche-entreprise/modifier" className="text-gray-300 hover:text-[#2BD391]" data-testid="footer-correction">Modifier / retirer une fiche</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow text-[#2BD391] mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#2BD391]" /> demenageurpro.contact@gmail.com</li>
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#2BD391]" /> <a href="tel:+33185117296" className="hover:text-[#2BD391]">01 85 11 72 96</a></li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#2BD391]" /> France entière</li>
            </ul>
            <Link to="/admin/login" className="inline-block mt-6 text-xs uppercase tracking-[0.22em] text-gray-500 hover:text-[#2BD391]" data-testid="footer-admin">
              Espace admin →
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 text-xs text-gray-400 flex flex-col md:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} Déménageur Pro. Tous droits réservés.</div>
          <div>Plateforme française · Données hébergées en UE</div>
        </div>
      </div>
    </footer>
  );
};
